var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_001-information",
    "data-name": "001-information",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.68,
    height: 29.68,
    viewBox: "0 0 29.68 29.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M14.84,0A14.84,14.84,0,1,0,29.68,14.84,14.857,14.857,0,0,0,14.84,0Zm0,26.982A12.142,12.142,0,1,1,26.982,14.84,12.155,12.155,0,0,1,14.84,26.982Z",
    fill: "#007be8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M146.8,70a1.8,1.8,0,1,0,1.8,1.8A1.8,1.8,0,0,0,146.8,70Z",
    transform: "translate(-131.961 -63.704)",
    fill: "#007be8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M151.349,140A1.349,1.349,0,0,0,150,141.349v8.094a1.349,1.349,0,1,0,2.7,0v-8.094A1.349,1.349,0,0,0,151.349,140Z",
    transform: "translate(-136.509 -127.409)",
    fill: "#007be8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.3d798a17d86fab394c227914a12fa54f.svg";
export { ForwardRef as ReactComponent };